(() => {
  'use strict';
  const key = Symbol.for('seldravinpack.utilityPages');
  if (window[key]) return;
  window[key] = true;
  document.addEventListener('change', event => { if (event.target.matches('[data-auto-submit]')) event.target.form?.requestSubmit(); });
  document.addEventListener('input', event => { if (event.target.matches('[data-cart-page] [name="note"]')) event.target.dataset.edited = 'true'; });
  let request = null;
  document.addEventListener('cart:updated', async () => {
    const root = document.querySelector('[data-cart-page]');
    if (!root) return;
    request?.abort(); const controller = new AbortController(); request = controller;
    const form = root.querySelector('[data-full-cart-form]');
    const note = root.querySelector('[name="note"]');
    const savedNote = note?.dataset.edited ? note.value : null;
    form?.setAttribute('aria-busy', 'true');
    form?.querySelectorAll('input,textarea,button').forEach(el => { el.disabled = true; });
    try {
      const url = new URL(root.dataset.cartUrl, location.origin); url.searchParams.set('section_id', root.dataset.sectionId);
      const response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Cart refresh failed');
      const next = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-cart-page]');
      if (!next) throw new Error('Missing cart section');
      if (savedNote !== null && next.querySelector('[name="note"]')) { next.querySelector('[name="note"]').value = savedNote; next.querySelector('[name="note"]').dataset.edited = 'true'; }
      if (root.isConnected && request === controller) root.replaceWith(next);
    } catch (error) {
      if (error.name !== 'AbortError' && root.isConnected) root.querySelector('[data-cart-page-status]').hidden = false;
      // Leave stale cart controls disabled; a reload is needed before checkout.
    }
  });
})();
